const Subscription = {
  subscription: 'Subscriptions',
  addSubscription: 'Add Subscription',
  editSubscription: 'Edit Subscription',
};
export default Subscription;
